import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useT } from "@/lib/i18n";
import { toast } from "sonner";
import { PlayCircle } from "lucide-react";
import HelpVideoPlayer from "@/components/HelpVideoPlayer";

/**
 * Small "▶ Watch Video" button dropped onto important screens.
 * Fetches the training video linked to `screen` on click and plays it
 * in-app; falls back to the Help Center when none is configured yet.
 */
export default function HelpVideoButton({ screen, label, labelKey, size = "sm" }) {
  const { t } = useT();
  const nav = useNavigate();
  const [video, setVideo] = useState(null);
  const [open, setOpen] = useState(false);

  const click = async () => {
    try {
      const r = await api.get(`/help/screen/${screen}`);
      if (r.data?.video) {
        setVideo(r.data.video);
        setOpen(true);
      } else {
        toast.info(t("help.comingSoon"));
        nav("/help");
      }
    } catch {
      nav("/help");
    }
  };

  return (
    <>
      <Button variant="outline" size={size} className="rounded-full" onClick={click} data-testid={`help-video-btn-${screen}`}>
        <PlayCircle className="w-4 h-4 mr-1" /> {label || (labelKey ? t(labelKey) : t("help.watchVideo"))}
      </Button>
      {video && <HelpVideoPlayer video={video} open={open} onOpenChange={setOpen} />}
    </>
  );
}
